import * as runtime from '@/api/runtime'
import {
  BatchTrcBooksOrderDataCreateRequest,
  BatchTrcBooksOrderDataCreateRequestToJSON,
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api/models/batch'
import {
  BatchTrcBooksOrderDataCreateCondition,
  BatchTrcBooksOrderDataCreateConditionFromJSON
} from '@/api/models/batch/BatchTrcBooksOrderDataCreateCondition'

/**
 * 帳票作成
 */
export class BatchTrcBooksOrderDataCreateApi extends runtime.BaseAPI {
  async output(request: BatchTrcBooksOrderDataCreateRequest): Promise<any> {
    const response = await this.requestPost(
      `/batch/order-accept/trc-books-order-data-create`,
      BatchTrcBooksOrderDataCreateRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }

  async getInitialCondition(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchTrcBooksOrderDataCreateCondition> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchTrcBooksOrderDataCreateConditionFromJSON(jsonValue)
    ).value()
  }
}
